import {
  Box,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@mui/material";
import TableRows from "./tableRows";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });
};

const OrderAndAccountInfo = ({ order_ }) => {
  return (
    <Box>
      <Typography sx={{ fontWeight: 500 }} textAlign={"center"} mb={2}>
        Ordre- og kontooplysninger
      </Typography>

      <TableContainer
        variant={"Paper"}
        sx={{ mb: 5, boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)" }}
      >
        <Table aria-label="simple table">
          <TableBody>
            <TableRows title={"Ordre nr."} value={order_.order_serial} />
            <TableRows title={"Rekv. nr."} value={order_.order_ref} />
            <TableRows
              title={"Ordre kommentar"}
              value={`${order_.order_comment}`}
            />
            <TableRows
              title={"Ordre dato"}
              value={formatDate(order_.updated_at)}
            />
            <TableRows
              title={"Leveringsmetode"}
              value={order_.shipping_method}
            />
            <TableRows title={"Kunde e-mail"} value={order_.customer_email} />
            <TableRows title={"E-mail status"} value={order_.email_status} />
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OrderAndAccountInfo;
